import { useAtom } from 'jotai';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { reservationDataAtom } from '../jotai-atoms/reservation-data.atom';
import { LiveClassBookingService } from '../services/liveclass-booking';
import { LiveClassShiftListItemProps } from './LiveClassShiftListItem';
import { Modal, ModalProps } from './Modal';

export interface ModalReservationCancelProps {
  show: boolean;
  onClose: () => void;
  liveClass: LiveClassShiftListItemProps;
}

export const ModalReservationCancel: FC<ModalReservationCancelProps> = ({
  show,
  onClose,
  liveClass,
}) => {
  const __ = useTranslation().t;

  const [reservationData, setReservationData] = useAtom(reservationDataAtom);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const modalProps: ModalProps = {
    show,
    onClose,
    type: 'default',
    title: __('unableToAttendClass'),
    submitButtonText: __('yesCancelClass'),
    cancelButtonText: __('noIWillAttend'),
  };

  const onSubmit = () => {
    if (!liveClass?.liveClassId) {
      return;
    }
    setIsLoading(true);
    LiveClassBookingService.cancelLiveClass({
      liveclass_id: liveClass.liveClassId,
    })
      .then(() => {
        setReservationData({
          ...reservationData,
          forceRefreshUserData: !reservationData?.forceRefreshUserData,
        });
        onClose();
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        alert(__('whopsSomethingWentWrong'));
      });
  };

  return (
    <StyledModal {...modalProps} onSubmit={onSubmit} submitButtonDisabled={isLoading}>
      <StyledText>{__('cancelClassConfirmationMessage')}</StyledText>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  max-width: 630px;
`;

const StyledText = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary.regular.fontFamily};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.dark};
`;
